import request from '~services/request';
export const NotificationsService = {
    getAll: () => request.get('/notices').then(response => response.data.data)
};
